import { Component, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { PreviewRequest } from '../../models/PreviewRequest';
import { PreviewService } from '../../services/preview.service';
import { NgModel, NgForm } from '@angular/forms';
import { environment } from 'environments/environment';

@Component({
  selector: 'mpf-request-preview-dialog',
  templateUrl: './request-preview-dialog.component.html',
  styleUrls: ['./request-preview-dialog.component.scss']
})
export class RequestPreviewDialogComponent {
  @ViewChild('requestPreviewForm') requestPreviewForm: NgForm;
  @ViewChild('emailInput') emailInput: NgModel;

  previewRequest: PreviewRequest;

  status: 'initial' | 'submitting' | 'done' | 'error' = 'initial';

  triedSubmitAndFailed = false;

  public dataPrivacyPolicyURL = environment.dataPrivacyPolicyURL;

  constructor(private dialogRef: MatDialogRef<RequestPreviewDialogComponent>, private previewService: PreviewService) {}

  requestPreview() {
    if (this.requestPreviewForm.form.valid) {
      this.status = 'submitting';

      // TODO: find a better approach to handle window resize <--> map resize
      // This timeout is required because when the android keyboard appears it generates resize events that modify
      // the space availalble for the map. This causes the map bounds to be modified when it shouldn't.
      // With the timeout we give the app time to remove the keyboard and resize the map to its original dimensions
      // without keyboard.
      setTimeout(() => {
        this.previewService
          .requestPreview(this.previewRequest)
          .then(() => {
            this.status = 'done';
          })
          .catch(err => {
            this.status = 'error';
          });
      }, 150);
    } else {
      this.triedSubmitAndFailed = true;
    }
  }

  shouldDisplayInvalidEmail() {
    // Only display invalid email if the user tried to submit.
    return this.triedSubmitAndFailed && this.emailInput && this.emailInput.invalid;
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/components/request-preview-dialog/request-preview-dialog.component.ts